/**
 * begin-password-reset-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Todd L Smith <tsmith@safetyweb.org>
 */

import { Message, ReplyVerifyingMessage } from "../../general/reply-message";
import { MessageTag } from "../../message-tag";

/**
 * A client transmits a {@link BeginPasswordResetRequest} to begin an
 * interaction to reset a user's password. What follows are a series of {@link
 * CredentialChallengeServerRequest}-{@link CredentialChallengeClientResponse}
 * exchanges that ask the user to prove her identity. If the server reliably
 * accepts the user's provided answers, and no prompts remain unanswered, then
 * the server sends a {@link NewPasswordServerRequest}.
 */
export class BeginPasswordResetRequest extends Message
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_BEGIN_PASSWORD_RESET;
	public static tag : MessageTag = MessageTag.REQ_BEGIN_PASSWORD_RESET;

  public expectsReply () : boolean
  {
    // NOTE: This is actually one of the few messages that *can* get replies but
    // doesn't necessarily *expect* them. We need to say true because otherwise
    // the extra replies get thrown out.
    return true;
  }

  /**
   * Construct a new {@link BeginPasswordResetRequest}.
   *
   * @param token
   *        The reset token supplied in the email sent to the user's registered
   *        email address.
   */
  constructor (public token : string)
  {
    super();
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/auth/credentials/begin-password-reset-request.ts